<template>
  <section class="login">
    <nav-bar :name="'Painel Administrativo'"></nav-bar>

    <div class="body">
      <div class="form">
        <label>Email</label>
        <input type="email" placeholder="Digite seu email" id="email" name="email" v-model="form.email">

        <label>Senha</label>
        <input type="password" placeholder="Digite sua senha" id="password" name="password" v-model="form.password">

        <button @click="sigIn()" class="button">
          <span v-if="!loading">Entrar</span>
          <v-icon name="spinner" spin v-else></v-icon>
        </button>
      </div>
    </div>

    <bottom-bar></bottom-bar>
  </section>
</template>
<style lang="scss">
  .login {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100vh;

    .body {
      margin: auto;
      margin-top: 100px;
      margin-bottom: 100px;
      width: 40%;
      display: block;

      @media (max-width: 1024px) {
        width: 90%!important;
      }

      .form {
        input {
          width: 98%;
          padding: 0 0 4px 10px;
          height: 34px;
          font-size: 1em;
          background: none;
          border: 1px solid rgba(60, 60, 60, 0.26);
          border-radius: 4px;
          font-weight: 300;
          margin-bottom: 20px;
        }

        .button {
          font-size: 24px;
          background-color: #08F;
          color: #fff;
          border: none;
          border-radius: 5px;
          padding: 10px 30px 10px 30px;
          display: block;
          margin: auto;
          margin-top: 30px;
          cursor: pointer;

          &:hover {
            background-color: rgb(0, 97, 182);
            transition: .3s;
          }
        }
      }
    }
  }
</style>
<script>
export default {
  data() {
    return {
      form: {},
      loading: false,
    };
  },

  methods: {
    sigIn() {
      this.loading = true;

      this.auth.signInWithEmailAndPassword(this.form.email, this.form.password)
        .then((user) => {
          this.getUserInfos(user.user.email);
        })
        .catch((error) => {
          this.loading = false;
          this.bus.$emit('alert', {
            status: 'error',
            message: error.message,
          });
        });
    },

    getUserInfos(user) {
      this.db.collection('users').doc(user)
        .get()
        .then((u) => {
          sessionStorage.setItem('currentUser', JSON.stringify(u.data()));
          this.loading = false;
          this.$router.push({ name: 'Panel Page' });
        })
        .catch((error) => {
          this.loading = false;
          this.bus.$emit('alert', {
            status: 'error',
            message: error.message,
          });
        });
    },
  },
};
</script>
